import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeDetectorRef, Component, HostListener, Inject } from '@angular/core';
import { ApiService } from 'src/app/services/apiService/api.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { NgFor } from '@angular/common';
import { MatButton } from '@angular/material/button';


interface Branch {
  Name: string;
  ID: number;
}

interface Department {
  Name: string;
  ID: number;
}

@Component({
    selector: 'app-filter-traveller',
    templateUrl: './filter-traveller.component.html',
    styleUrls: ['./filter-traveller.component.scss'],
    imports: [ReactiveFormsModule, MatCheckbox, NgFor, MatButton]
})




export class FilterTravellerComponent {

  CustomFilter!: FormGroup;


  status = {
    CONFIRMED: false,
    APPROVED: false,
    PENDING: false,
    REJECTED: false
  };


  // calendar declarations
  selectedExpiryDate: Date | null = null;
  selectedExpiryDate1: Date | null = null;
  minDate: any = {
    year: null,
    month: null,
    date: null
  }
  maxDate: any = {
    year: null,
    month: null,
    date: null
  }

  isCalendarVisible: { [key: string]: boolean } = {
    isDOBCalendarVisible2: false
  };
  isChildVisible: { [key: string]: boolean } = {
    isDOBCalendarVisible: false
  };
  isChildVisible0: { [key: string]: boolean } = {
    isDOBCalendarVisible0: false
  };
  isChildVisible1: { [key: string]: boolean } = {
    isDOBCalendarVisible1: false
  };
  isChildVisible2: { [key: string]: boolean } = {
    isDOBCalendarVisible2: false
  };
  isCalenderVisible: { [key: string]: boolean } = {
    FDate: false,
    ExpiryDate: false,
  };
  dateRanges2: Record<string, { minDate: Date; maxDate: Date }> = {};
  dateRanges: Record<string, { minDate: Date; maxDate: Date }> = {};
  dateRanges0: Record<string, { minDate: Date; maxDate: Date }> = {};



  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public _ApiService: ApiService, public _MatDialogRef: MatDialogRef<FilterTravellerComponent>,
    private cdr: ChangeDetectorRef,
  ) {

    this.CustomFilter = this.fb.group({
      branches: this.fb.array([]),
      departments: this.fb.array([]),
      CONFIRMED: [false],
      APPROVED: [false],
      PENDING: [false],
      REJECTED: [false],
      Active: "",
      Deactivated: "",
    });

    // Populate branches FormArray
    this.createControllers("branches", this.data.branchdata);
    // Populate departments FormArray
    this.createControllers("departments", this.data.Departmentdata);

  }


  createController(): FormGroup {
    return this.fb.group({
      checked: [null, Validators.required],
      ID: [null, Validators.required],
      // Name:$branch.Name,
    })
  }
  createControllers(controllerName: string, branches: Branch[]) {
    branches.forEach(($branch: any) => {
      (this.CustomFilter.get(controllerName) as FormArray).push(this.createController());
    });
  }
  bindID(controllerName: string, index: number, id: string, event: any) {
    if (event?.checked) {
      (this.CustomFilter.get(controllerName) as FormArray).at(index).get('ID')?.setValue(id);
    } else {
      (this.CustomFilter.get(controllerName) as FormArray).at(index).get('ID')?.setValue(null);
    }
  }

  applyFilters() {
    const selectedStatus = this.getSelectedStatus();
    const DeptBranch = this.generateFilteredStrings(this.CustomFilter.value);
    const filterData = {
      status: selectedStatus,
      DepartmentBranch: DeptBranch,

    };
    this._MatDialogRef.close()
    this._ApiService.travelerSubject1.next(filterData);
  }

  getSelectedStatus() {
    const selectedStatus = [];
    if (this.CustomFilter.get('Active')?.value) {
      selectedStatus.push('1');
    }
    if (this.CustomFilter.get('Deactivated')?.value) {
      selectedStatus.push('0');
    }

    return selectedStatus;
  }


  generateFilteredStrings(data: any) {
    // Generate the branch string with IDs of checked branches
    const branchIds = data.branches
      .filter((branch: { checked: boolean; ID: null; }) => branch.checked === true && branch.ID != null)  // Filter out null IDs
      .map((branch: { ID: any; }) => branch.ID)  // Get the IDs of checked branches
      .join(',');  // Join them with commas

    // Generate the department string with IDs of checked departments
    const departmentIds = data.departments
      .filter((department: { checked: boolean; ID: null; }) => department.checked === true && department.ID != null)  // Filter out null IDs
      .map((department: { ID: any; }) => department.ID)  // Get the IDs of checked departments
      .join(',');  // Join them with commas

    return {
      branchString: branchIds,
      departmentString: departmentIds
    };
  }


  inputPasteValidator(event: ClipboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const pastedData = event.clipboardData?.getData('text') || '';
    const allowedRegex = /^[a-zA-Z() ]*$/;
    const sanitizedData = Array.from(pastedData)
      .filter(char => allowedRegex.test(char))
      .join('');
    if (sanitizedData !== pastedData) {
      event.preventDefault();
      const currentValue = inputElement.value;
      const cursorPosition = inputElement.selectionStart || 0;
      const updatedValue =
        currentValue.slice(0, cursorPosition) +
        sanitizedData +
        currentValue.slice(cursorPosition);

      inputElement.value = updatedValue;
      inputElement.setSelectionRange(
        cursorPosition + sanitizedData.length,
        cursorPosition + sanitizedData.length
      );
    }
  }

  blockInvalidCharactersForExpiryDate(event: KeyboardEvent): void {
    const allowedKeys = /^[0-9\-\/]$/;
    if (!allowedKeys.test(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }



  pasteControlHTMLTags(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text/plain') || '';
    if (!/^[0-9\-\/]+$/.test(pastedData)) {
      event.preventDefault();
    }
  }
  onConfirm2(componentKey: string) {
    this.hideComponent2(componentKey);
  }

  hideComponent2(componentKey: string): void {
    this.isChildVisible2[componentKey] = false;
  }

  private formatDate(date: Date | null): string {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }



  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    const clickedElement0 = event.target as HTMLElement;
    const isClickInside =
      !clickedElement.closest('custom-cls');
    const isClickInside0 =
      clickedElement0.closest('mat-form-field') ||
      clickedElement0.closest('.datepicker-content-container');
    if (!isClickInside) {
      this.isChildVisible['isDOBCalendarVisible'] = false;
      this.isChildVisible0['isDOBCalendarVisible0'] = false;
      this.isChildVisible1['isDOBCalendarVisible1'] = false;
      this.isChildVisible2['isDOBCalendarVisible2'] = false;
      this.cdr.detectChanges();
    }
  }

}
